<div
  class="pdf-viewer-content"
  [style.width]="size?.width"
  [style.height]="size?.height"
  [style.max-width]="getMaxWidth()"
  [style.max-height]="getMaxHeight()"
>
  <div class="controls-wrapper">
    <!-- Zoom controls: -->
    <div class="zoom-controls-outer-wrapper">
      <div class="zoom-controls-inner-wrapper">
        <div class="gap">
          <app-icon [name]="IconName.minus" (click)="zoomOut()" [ngClass]="{ disabled: zoom === zoomMin }"></app-icon>
          <input
            type="range"
            [min]="zoomMin"
            [max]="zoomMax"
            step="0.05"
            [ngModel]="zoom"
            (ngModelChange)="zoomChanged($event)"
            class="slider"
          />
          <app-icon [name]="IconName.plus" (click)="zoomIn()" [ngClass]="{ disabled: zoom === zoomMax }"></app-icon>
        </div>
        <span>{{ zoom.toFixed(2) }}x</span>
      </div>
      <rc-link
        data-qa="vs-pdf-preview-popin-button-reset-zoom"
        variant="secondary"
        size="large"
        [disabled]="zoom === 1"
        (click)="resetZoom()"
      >
        {{ 'Zoom-to-fit' | translateKey }}
      </rc-link>
    </div>

    <!-- Close button: -->
    <app-icon [name]="IconName.close" (click)="close()"></app-icon>
  </div>

  <!-- PDF viewer: -->
  <div #pdfContainer class="pdf-container"></div>

  <!-- Page navigation controls: -->
  @if (!showAllPages && totalPages > 1) {
    <div class="controls-wrapper central">
      <div class="gap">
        <rc-link
          data-qa="vs-pdf-preview-popin-button-previous-page"
          variant="secondary"
          size="large"
          [disabled]="currentPage === 1"
          (click)="prevPage()"
        >
          {{ 'Previous' | translateKey }}
        </rc-link>
        <span>{{ 'Page-scroll' | translateKey: { page: currentPage, totalPages: totalPages } }}</span>
        <rc-link
          data-qa="vs-pdf-preview-popin-button-next-page"
          variant="secondary"
          size="large"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()"
        >
          {{ 'Next' | translateKey }}
        </rc-link>
      </div>
    </div>
  }
</div>
